module.exports = __webpack_public_path__ + "media/thelastwaltz.a32610d7.mp3";